import { analyticsAxios } from '.'

export const getSignedUrl = (token, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await analyticsAxios.post('/analytics/s3/signed_urls', data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      if (response.data.statusCode === 200) {
        resolve(response.data)
      } else {
        reject(response.data.error)
      }
    } catch (error) {
      reject(error)
    }
  })
}

export const putObject = (token, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await analyticsAxios.post('/analytics/s3/put_object', data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      if (response.data.statusCode === 200) {
        resolve(response.data)
      } else {
        reject(response.data.error)
      }
    } catch (error) {
      reject(error)
    }
  })
}

export const getObject = (token, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await analyticsAxios.post('/analytics/s3/get_object', data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      if (response.data.statusCode === 200) {
        resolve(response.data)
      } else {
        resolve({})
      }
    } catch (error) {
      resolve({})
    }
  })
}

export const deleteObject = (token, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await analyticsAxios.post('/analytics/s3/delete_object', data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      if (response.data.statusCode === 200) {
        resolve(response.data)
      } else {
        resolve({})
      }
    } catch (error) {
      resolve({})
    }
  })
}

export const sendMessage = (token, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await analyticsAxios.post('/analytics/sns/send_message', data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      if (response.data.statusCode === 200) {
        resolve(response.data)
      } else {
        reject(response.data.error)
      }
    } catch (error) {
      reject(error)
    }
  })
}

export const getSSM = (token, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await analyticsAxios.post('/analytics/ssm/3pf', data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      if (response.data.statusCode === 200) {
        resolve(response.data)
      } else {
        reject(response.data.error)
      }
    } catch (error) {
      reject(error)
    }
  })
}
